<template>
	<span>
		{{ text }}
		<span class="red--text">({{ $T('required') }})</span>
	</span>
</template>

<script>
export default {
	name: 'RequiredLabel',
	props: {
		text: {
			type: String,
			required: true
		}
	}
}
</script>
